async function req<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

const get = <T>(url: string) => req<T>(url)
const post = <T>(url: string, body: any) => req<T>(url, { method: 'POST', body: JSON.stringify(body) })
const put = <T>(url: string, body: any) => req<T>(url, { method: 'PUT', body: JSON.stringify(body) })
const patch = <T>(url: string, body: any) => req<T>(url, { method: 'PATCH', body: JSON.stringify(body) })
const del = <T>(url: string) => req<T>(url, { method: 'DELETE' })

export const api = {
  // Auth
  getShops: () => get<any[]>('/api/shops'),
  getUsers: (shopId: string) => get<any[]>(`/api/auth/login?shop_id=${shopId}`),
  login: (userId: string, pin: string) => post<any>('/api/auth/login', { user_id: userId, pin }),

  // Setup
  setup: (shopName: string, userName: string, pin: string) =>
    post<any>('/api/setup', { shop_name: shopName, user_name: userName, pin }),

  // Articles
  getArticles: (shopId: string, params?: { inStock?: boolean; search?: string }) => {
    const p = new URLSearchParams({ shop_id: shopId })
    if (params?.inStock) p.set('in_stock', '1')
    if (params?.search) p.set('search', params.search)
    return get<any[]>(`/api/articles?${p}`)
  },
  getArticle: (id: string) => get<any>(`/api/articles/${id}`),
  createArticle: (body: any) => post<any>('/api/articles', body),
  updateArticle: (id: string, body: any) => put<any>(`/api/articles/${id}`, body),
  deleteArticle: (id: string) => del<any>(`/api/articles/${id}`),
  ajustStock: (id: string, body: any) => patch<any>(`/api/articles/${id}`, body),
  importArticles: (articles: any[]) => post<any>('/api/articles', articles),

  // Caisse
  getCaisse: (shopId: string, date: string) =>
    get<any>(`/api/caisse?shop_id=${shopId}&date=${date}`),
  openCaisse: (shopId: string, userId: string, solde: number) =>
    post<any>('/api/caisse', { shop_id: shopId, user_id: userId, solde_ouverture: solde }),

  // Retraits
  addRetrait: (body: any) => post<any>('/api/retraits', body),

  // Charges
  addCharge: (body: any) => post<any>('/api/charges', body),
  getCharges: (shopId: string, from: string, to: string) =>
    get<any[]>(`/api/charges?shop_id=${shopId}&from=${from}&to=${to}`),

  // Ventes
  createVente: (body: any) => post<any>('/api/ventes', body),

  // Rapport
  getRapport: (shopId: string, from: string, to: string) =>
    get<any>(`/api/rapport?shop_id=${shopId}&from=${from}&to=${to}`),

  // Users
  getShopUsers: (shopId: string) => get<any[]>(`/api/users?shop_id=${shopId}`),
  createUser: (body: any) => post<any>('/api/users', body),
  deleteUser: (id: string) => del<any>(`/api/users?id=${id}`),

  // Clients
  getClients: (shopId: string, search?: string) => {
    const p = new URLSearchParams({ shop_id: shopId })
    if (search) p.set('search', search)
    return get<any[]>(`/api/clients?${p}`)
  },
  getClient: (id: string) => get<any>(`/api/clients/${id}`),
  createClient: (body: any) => post<any>('/api/clients', body),
  updateClient: (id: string, body: any) => put<any>(`/api/clients/${id}`, body),
  deleteClient: (id: string) => del<any>(`/api/clients/${id}`),
  clientAvance: (id: string, montant: number, note?: string) =>
    post<any>(`/api/clients/${id}`, { type: 'avance', montant, note }),

  // Chat
  chat: (message: string, context: any, history: any[]) =>
    post<any>('/api/chat', { message, context, history }),
}
